import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import contactcomprahence from '../img/medicalbillingservices/Contract-compliance/credential-services.webp'
import globalcontracts from '../img/medicalbillingservices/Contract-compliance/global-contracts.webp';
import statewisecomploance from '../img/medicalbillingservices/Contract-compliance/statewise-compliance.webp';
import databasemaintain from '../img/medicalbillingservices/Contract-compliance/CAQH-database-maintenance.webp'
import independentaudit from '../img/Conseltancyservices/internal-audit-consultancy.webp'; 
import "../css/servicesfont.css";
export default function CredentialingDesc() {
  return (
    <MDBContainer fluid className="p-0 bg-light">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 mb-5">
            <div className="row">
              <div class="col-md-4 mb-2 text-center ">
                <img src={contactcomprahence} width={350} height={250} alt="Contractor compliance requirements"/>
              </div>
              <div class="col-md-8">
                <h2 className="title AcerhealthTextPurple fontsizeset2" style={{fontFamily:'Alegreya Sans',fontWeight:'bold'}}>
                  Credential Services
                </h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
                <p className="mt-3 mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',textAlign:'justify' }}>
              Our experienced and dedicated team handles the entire <b>provider credentialing </b>process for your practice — from 
              submitting application forms to establishing contracts with insurance providers. We identify the top insurance 
              carriers based on your location and specialty, ensuring you’re credentialed with the right partners. 
              This strategic approach supports <b>medical billing outsourcing</b> and strengthens your <b>revenue cycle management, </b>
              helping maximize reimbursement potential and drive predictable revenue from day one. Let AcerHealth streamline
               your credentialing so you can focus on delivering quality care with confidence.    </p>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-5">
            <div className="row">
              <div class="col-md-4 mb-2 text-center ">
                <img src={globalcontracts} width={350} height={250} alt="global contract with TPAs"/>
              </div>
              <div class="col-md-8">
                <h2 className="title AcerhealthTextPurple fontsizeset2" style={{fontFamily:'Alegreya Sans',fontWeight:'bold'}}>
                  Global Contracts with TPAs
                </h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
                <p className="mt-3 mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',textAlign:'justify'}}>
                At AcerHealth, we coordinate and negotiate with Third Party Administrators (TPAs) to establish international contracts for 
                your medical services. These agreements improve reimbursement rates and offer flexible payment terms to enhance your practice’s 
                cash flow. Our expertise in
                 <a
                            href="https://acerhealth.com/services/denial-management-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
            healthcare denial management,
                        </a>  
                 medical billing compliance services, and EMR billing integration ensures 
                streamlined operations and reduced claim denials. Partner with us to expand your reach globally while maintaining regulatory compliance 
                and maximizing predictable revenue.  </p>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-5">
            <div className="row">
              <div class="col-md-4 mb-2 text-center p-0">
                <img src={statewisecomploance} width={350} height={250} alt="Statewise compliance"/>
              </div>
              <div class="col-md-8">
                <h2 className="title AcerhealthTextPurple fontsizeset2" style={{fontFamily:'Alegreya Sans',fontWeight:'bold'}}>
                  State-wise Compliance
                </h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
                <p className="mt-3 mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',textAlign:'justify'}}>
               Meeting state-specific quality reporting requirements is essential for healthcare centers to demonstrate service excellence and maintain compliance. For example,
                in New York, ambulatory surgery centers must submit patient quality data to SPARCS and HCRA reporting systems. At AcerHealth, we use a technology-driven process 
                to collect, consolidate, and submit data in SPARCS-compliant formats. We also assist ASCs in reporting HCRA data across states, ensuring full 
                 <a
                            href="https://acerhealth.com/services/medical-billing-and-credentialing"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
          medical billing compliance services.
                        </a>  
                 Partner with us to navigate your state’s quality mandates efficiently,
                 so you can focus on delivering exceptional patient care while optimizing your <b>revenue cycle management. </b> </p>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-5">
            <div className="row">
              <div class="col-md-4 mb-2 text-center ">
                <img src={databasemaintain} width={350} height={250} alt="CAQH Database maintenance"/>
              </div>
              <div class="col-md-8">
                <h2 className="title AcerhealthTextPurple fontsizeset2" style={{fontFamily:'Alegreya Sans',fontWeight:'bold'}}>
                  CAQH Database Maintenance
                </h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
               <p className="mt-3 mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',textAlign:'justify'}}>
              Physicians must regularly update and re-attest their CAQH profiles every 90 days to stay compliant. At AcerHealth, we proactively review your CAQH data,
               send timely reminders, and manage updates on your behalf. This service supports seamless <b>provider credentialing</b> and ensures your practice maintains full
                <b> medical billing compliance services,</b> helping to avoid delays in reimbursements and strengthen your overall 
                 <a
                            href="https://acerhealth.com/services/revenue-cycle-management"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
          revenue cycle management.
                        </a>  
                 </p>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-5">
            <div className="row">
              <div class="col-md-4 mb-2 text-center ">
                <img src={independentaudit} width={350} height={250} alt="Internal Audit"/>
              </div>
              <div class="col-md-8">
                <h2 className="title AcerhealthTextPurple fontsizeset2" style={{fontFamily:'Alegreya Sans',fontWeight:'bold'}}>
                  Internal Audits
                </h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
               <p className="mt-3 mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',textAlign:'justify'}}>
            Small practices often face time constraints that make thorough medical charge audits challenging. At AcerHealth, we partner with healthcare providers of all 
            sizes to conduct comprehensive <b> healthcare billing audits </b>and develop customized quality protocols. Our expert team supports you through the audit process, 
            helping ensure full <b>medical billing compliance services </b>and regulatory adherence. By proactively managing audits, we help reduce denials and protect your revenue cycle,
             allowing you to focus on delivering quality patient care.
                
                 </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
}
